package amazon.lastmile.inject

import app.nestbridge.domain.ping.service.DefaultPingService
import app.nestbridge.domain.ping.service.PingService
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultPingService::class)
public interface AppNestbridgeDomainPingServiceDefaultPingService {
  @Provides
  public fun provideDefaultPingServicePingService(defaultPingService: DefaultPingService): PingService = defaultPingService
}
